import axios from "axios";

import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/reports`;

export const GetReportShifts = async (
  token,
  startDate,
  endDate,
  restaurant_id
) => {
  try {
    const response = await axios.get(
      `${API_URL}/shift_report/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurant_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    // if (error.status == 401) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("access_level");
    //   window.location.href = "/";
    // }
    return error.response.data;
  }
};

export const GetReportCHK = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/chk/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    // if (error.status == 401) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("access_level");
    //   window.location.href = "/";
    // }
    return error.response.data;
  }
};

export const GetReportEnergy = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/energy/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const GetReportEnergyXlsx = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/energy/xlsx/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const GetReportDeploymentAccuracy = async (
  token,
  startDate,
  endDate,
  restaurantId = 0,
) => {
  try {
    const response = await axios.get(
      `${API_URL}/deployment_accuracy/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const GetReportDeploymentAccuracyXlsx = async (
  token,
  startDate,
  endDate,
  restaurantId = 0,
) => {
  try {
    const response = await axios.get(
      `${API_URL}/deployment_accuracy/xlsx/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const GetReportPayroll = async (
  token,
  startDate,
  endDate,
  restaurantId = 0,
) => {
  try {
    const response = await axios.get(
      `${API_URL}/payroll/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const GetReportPayrollXlsx = async (
  token,
  startDate,
  endDate,
  restaurantId = 0,
) => {
  try {
    const response = await axios.get(
      `${API_URL}/payroll/xlsx/?start_date=${startDate}&end_date=${endDate}&restaurant_id=${restaurantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const GetReportMNG = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/mng/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    // if (error.status == 401) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("access_level");
    //   window.location.href = "/";
    // }
    return error.response.data;
  }
};
